import React, { useEffect, useState } from 'react';
import { ContentService } from '../../../services/ContentService';
import { ContentBannerDetail } from '../../../model/content';
import useMedias from '../../../hooks/useMedias';
import { getUrlLocalised, useTranslation } from '../../../hooks/use-translations';
import { useSiteContext } from '@zooplus/commons-lang';
import { P2 } from '@zooplus/ui-components';
import styles from './ContentBanner.module.scss';
import ReactDOM from 'react-dom';

export type ContentBannerProps = {
  productGroup: number;
  zone: string;
  textContainerId: string;
};

export const ContentBanner = ({ productGroup, zone, textContainerId }: ContentBannerProps) => {
  const { site, locale } = useSiteContext();
  const { isMobile, isSmallMobile, isBigDesktop } = useMedias();
  const { t } = useTranslation();

  const [bannerInfo, setBannerInfo] = useState<ContentBannerDetail | undefined>(undefined);

  useEffect(() => {
    ContentService(undefined)
      .getBanner(site.domain, locale, productGroup, zone)
      .then((response) => {
        if (response?.model?.middleBannerDetail?.targetLink) {
          setBannerInfo(response.model.middleBannerDetail);
        }
      });
  }, []);

  const image =
    bannerInfo?.mobileImage && (isMobile || isSmallMobile) ? (
      <img
        src={bannerInfo.mobileImage}
        alt={
          bannerInfo.mobileAltText || bannerInfo.desktopAltText || bannerInfo.superWideImageAltText
        }
      />
    ) : bannerInfo?.superWideImage && isBigDesktop ? (
      <img
        src={bannerInfo.superWideImage}
        alt={
          bannerInfo.superWideImageAltText || bannerInfo.desktopAltText || bannerInfo.mobileAltText
        }
      />
    ) : bannerInfo?.desktopImage && !(isMobile || isSmallMobile) ? (
      <img
        src={bannerInfo.desktopImage}
        alt={
          bannerInfo.desktopAltText || bannerInfo.superWideImageAltText || bannerInfo.mobileAltText
        }
      />
    ) : undefined;

  if (image) {
    const textContainer = document.getElementById(textContainerId) || undefined;
    if (textContainer) {
      ReactDOM.render(<P2>{t('campaign.text')}</P2>, textContainer);
    }
  }

  return image ? (
    <div className={styles.contentBanner}>
      {bannerInfo?.targetLink ? (
        <a className={styles.link} href={getUrlLocalised(t, `${bannerInfo.targetLink}`)}>
          {image}
        </a>
      ) : (
        image
      )}
    </div>
  ) : (
    <></>
  );
};
